import { render, staticRenderFns } from "./PoolItem.vue?vue&type=template&id=201e54ca&scoped=true&"
import script from "./PoolItem.vue?vue&type=script&lang=js&"
export * from "./PoolItem.vue?vue&type=script&lang=js&"
import style0 from "./PoolItem.vue?vue&type=style&index=0&id=201e54ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e54ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201e54ca')) {
      api.createRecord('201e54ca', component.options)
    } else {
      api.reload('201e54ca', component.options)
    }
    module.hot.accept("./PoolItem.vue?vue&type=template&id=201e54ca&scoped=true&", function () {
      api.rerender('201e54ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/PoolItem.vue"
export default component.exports